const statistical = {
  isSelect: "Please select the data to package",
  noSuccess: "Download failed",
  operation: {
    month: "Date",
    aperationMileage: "Mileage(km)",
    aperationTiemLenthen: "Time(min)",
    oil: "Fuel consumption(L)",
    oilPay: "Fuel costs(Baht)",
    carbonEmission: "Carbon",
    licenseplate: "Please enter the license plate number",
    searchWidth: {
      width1: "85px",
      width2: "50px",
      width3: "65px"
    },
    allAperationMileage: "Total operating mileage",
    allAperationTiemLenthen: "Total operating time",
    allOil: "Total fuel consumption",
    tripCount: "Number of trips",
    score: "Driving behaviour score",
    sharpturn: "Number of sharp turns",
    emergencyBrake: "Number of sharp deceleration",
    rapidAcceleration: "Number of rapid acceleration",
    emergencyBrakeWidth: "200px",
    rapidAccelerationWidth: "200px",
    sharpturnWidth: "200px"
  },
  hisDownloadSearch: {
    missionName: "Task name",
    downloadType: "Download type",
    downloadStatus: "Download status",
    searchLabelWidth: "110px",
    searchLabelWidth1: "80px",
    searchTitle: "Download subtask list",
    downloadPackage: "Download package"
  },
  hisDownloadTabel: {
    taskType: "Task type",
    downloadedVehicles: "Download vehicles",
    downloadProgress: "Download progress",
    downloader: "Founder",
    taskCreationTime: "Task creation time",
    instructions: "Instructions",
    start: "Initialization",
    queue: "Queue up",
    processing: "Processing",
    compressing: "Compressing",
    completed: "Completed",
    abnormal: "Abnormal",
    noHistoricalData: "No historical data",
    commonTasks: "Common tasks",
    urgentTasks: "Urgent tasks",
    startTime: "Download start time",
    endTime: "Download end time"
  },
  hisDownloadTabelWidth: {
    tabelWidth1: "120px",
    tabelWidth2: "100x",
    tabelWidth3: "160px"
  },
  hisTips: {
    taskInfo: "The task is in progress and cannot be deleted",
    isDelete: "Delete or not",
    isSelect: "Please select task",
    noSuccess: "Task download status not completed",
    stateInfo: "task not set"
  },
  boxAddTask: {
    addTask: "Add task",
    selectVehicle: "Select vehicle",
    selectParameters: "Select parameters",
    carInfo: "No vehicle is selected at current time",
    tabelWidth: "110px",
    select: "has been chosen",
    selectDes: "Vehicle",
    operatingArea: "Operating area",
    terminalNumber: "Terminal number",
    brand: "Brand",
    model: "Model",
    series: "Series",
    projectCode: "Project code",
    modelName: "Model name",
    forCar: "For car",
    ignites: "Ignites",
    standardCar: "For the car",
    error: {
      selectTaskName: "Please enter a task name",
      selectVehicle: "Please select vehicle",
      selectStartTime: "Please select the start time",
      selectEndTime: "Please choose the end time",
      selectDownloadType: "Please select the download type",
      selectTimes: "Start time is not greater than end time， please choose again"
    },
    parameters: {
      parameterName: "Parameter name"
    },
    width1: "95px",
    width2: "110px"
  },
  tripvicel: {
    downOBD: "Total",
    obdwidth: "110px",
    carInfo: "No OBD is selected at current time",
    selectDes: "OBD",
    samplingRate: "Sampling rate",
    errorsamplingRate: "Please enter the sampling rate",
    querytime: "Download time"
  }
} 
export default statistical